// TODO: get this from CF content instead of hardcoding?
const PACKAGE_ID_BY_SLUG: Record<string, number> = {
    start: 232831376,
    basic: 962803814,
    max: 760357282,
};

export const getPackageIdFromSlug = (slug?: string): number | undefined => {
    const key = slug?.trim().toLowerCase() ?? "";
    return Object.hasOwn(PACKAGE_ID_BY_SLUG, key) ? PACKAGE_ID_BY_SLUG[key] : undefined;
};

export const getPackageSlugFromId = (packageId?: number | string): string | undefined =>
    Object.entries(PACKAGE_ID_BY_SLUG).find(([, id]) => String(id) === String(packageId))?.[0];
